import { render, staticRenderFns } from "./VDesignChangelogItem.vue?vue&type=template&id=12354ec4&"
import script from "./VDesignChangelogItem.vue?vue&type=script&lang=ts&"
export * from "./VDesignChangelogItem.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignChangelogItem.vue?vue&type=style&index=0&id=12354ec4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports